import { createSlice } from '@reduxjs/toolkit'


const initialState = {
   items: {}
}

const compareSlice = createSlice({
   name: 'compare',
   initialState,
   reducers: {
      toggleCompare(state, action) {
         if (action.payload in state.items) delete state.items[action.payload]
         else state.items[action.payload] = true
      },
      removeCompareItem(state, action) {
         delete state.items[action.payload]
      }
   }
})

export const compare = compareSlice.reducer
export const { toggleCompare, removeCompareItem } = compareSlice.actions
